import { SkinPreview } from "./ui/SkinPreview";

/**
 * Endless-mode paddle/ball cosmetic preview shown inside the pause overlay.
 *
 * Extracted from `GameCanvas.jsx` on 2026-05-13. Lets pilots swap or try a
 * locked skin without leaving the run; the `previewSkin` banner echoes
 * the temporary trial state with a soft pulse animation.
 *
 * Renders nothing when not in `endless` mode — the wrapper used to live
 * inline behind an `{endless && (...)}` guard.
 */
export function PauseSkinRow({
  endless,
  walletCfg,
  previewSkin,
  onSwap,
  onTry,
}) {
  if (!endless) return null;
  return (
    <div
      className="w-full max-w-md mb-3 flex flex-col items-center gap-2"
      data-testid="pause-skin-row"
    >
      <SkinPreview
        palette={walletCfg.skinPalette}
        name={walletCfg.skinName}
        ownedSkins={walletCfg.ownedSkins}
        skinsCatalog={walletCfg.skinsCatalog}
        activeSkin={walletCfg.activeSkin}
        onSwap={onSwap}
        onTry={onTry}
      />
      {previewSkin && (
        <div
          className="px-3 py-1.5 border bg-black/50 font-mono-cosmic text-[10px] tracking-[0.25em] uppercase flex items-center gap-2 animate-pulse"
          style={{
            borderColor: `${previewSkin.palette?.mid || "#c084fc"}aa`,
            color: previewSkin.palette?.mid || "#c084fc",
            boxShadow: `0 0 12px ${previewSkin.palette?.mid || "#c084fc"}55`,
          }}
          data-testid="pause-skin-preview-banner"
        >
          <span>· Trying {previewSkin.name} ·</span>
          <span className="text-[#c084fc]">{previewSkin.cost} ☾</span>
          <span className="text-white/60">on /skins</span>
        </div>
      )}
    </div>
  );
}
